let sidebarAppModules = window.backoffice.settings.sidebar.map(
  ({ app, href, disable }) => ({
    app,
    href,
    disable,
  })
);
window.backoffice.settings.sidebar
  .filter(({ sub }) => sub)
  .forEach(({ sub }) => {
    sidebarAppModules = [
      ...sidebarAppModules,
      ...sub
        .filter(({ app }) => app)
        .map(({ app, href, disable }) => ({
          app,
          href,
          disable,
        })),
    ];
  });

function bootstrapBackOffice(e) {
  // search for aggregator_app_url
  window.aggregator_app_url = sidebarAppModules.find(
    (element) => element.app === 'aggregator_boclient' && !element.disable
  )?.href;

  // search for admin_app_url
  window.admin_app_url = sidebarAppModules.find(
    (element) => element.app === 'admin_boclient' && !element.disable
  )?.href;

  // get location href and delete trailing slash
  window.spa_app_url = window.location.href.split('#')[0].replace(/\/+$/, '');

  import('./bootloader').catch((err) => console.error(err));
}

function checkMissingPlatformModule() {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', window.platform_app_url);
    xhr.onload = resolve;
    xhr.onerror = reject;
    xhr.send();
  });
}
if (window.backoffice.settings.forceMissingPlatform) {
  bootstrapBackOffice();
} else {
  // search for platform_app_url
  window.platform_app_url = sidebarAppModules.find(
    (element) => element.app === 'platform_boclient' && !element.disable
  )?.href;

  checkMissingPlatformModule().then(
    () => {
      bootstrapBackOffice();
    },
    () => {
      // reset related window settings if platform module is missing
      window.platform_app_url = undefined;
      window.forcePlatformForPlayerProfile = false;
      bootstrapBackOffice();
    }
  );
}
